module.exports = __webpack_public_path__ + "static/media/codepipeline.090ec8e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/codepipeline.png
// module id = 154
// module chunks = 0